import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from 'react-toastify';
import { setMessage } from "../../actions/message";
import { getCompany, upsertCompany } from "../../actions/company";
import { useEffect } from "react";
import { getAirports, deleteAirport, upsertAirport } from "../../actions/airport";
import { clearMessage } from "../../actions/message";
import Filter from "../Filter";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGridPro, GridActionsCellItem } from '@mui/x-data-grid-pro';
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import NewAirportModal from "./NewAirportModal";

const Airport = (props) => {

  let airportsLoaded = false;
  const dispatch = useDispatch();
  const searchBarHelper = "Search for an airport...";
  const { airports: listAirports } = useSelector((state) => state.airports);
  const [filter, setFilter] = useState("");
  const [activeFilter, setActiveFilter] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [selectedAirport, setSelectedAirport] = useState(null);
  
  const handleClickOpenDialog = () => {
    let airport_tmp = {};
    airport_tmp.id = 0;
    airport_tmp.name = "";
    airport_tmp.active = 1;
    setSelectedAirport(airport_tmp);
    setModalShow(true);
  };

  const handleCloseDialog = () => {
    setModalShow(false);
    setSelectedAirport(null);
  };

  useEffect(() => {
    if (!airportsLoaded) {
      dispatch(getAirports()).then(() => {
        airportsLoaded = true;
      }).catch((e) => {
      });
    }
  }, []);

  const updateActiveFilter = (e) => {
    setActiveFilter(e.target.checked);
  }

  const HandleFilter = (e) => {
    setFilter(e.toLowerCase());
  };

  function filterAirports(airport) {
    if (airport.id > 0) {
      if (!airport.active && activeFilter) {
        return false
      }

      if (airport.name) {
        return airport.name.toLowerCase().includes(filter);
      } else {
        return true;
      }
    }
  }

  const handleRowClick = (params) => {
    if (params.id > 0) {
      const airport = listAirports.filter(airport => { return airport.id === params.id })[0]
      if (airport.id <= 0) { return; }
      setSelectedAirport(airport);
      setModalShow(true);

    }
  };

  const upsert_airport = () => {

    setModalShow(false);
    if ((selectedAirport.id >= 0 && selectedAirport.name != "")) {
      dispatch(upsertAirport(selectedAirport))
        .then(() => {
          toast.success(
            `Airport ${selectedAirport.id > 0 ? "updated" : "created"} successfuly`,
            { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
          );
        })
        .catch(() => {
          toast.error(
            `An Error occured while ${selectedAirport.id > 0 ? "updating" : "creating"} the airport. Try again later.`,
            { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
          );
        });
    }

    setSelectedAirport(null);

  }

  const DataGrid = styled(DataGridPro)(({ theme }) => ({
    "& .MuiDataGrid-columnHeaders": { display: "none" },
    "& .MuiDataGrid-virtualScroller": { marginTop: "0!important" },
  }));

  const delete_airport = (airport_id) => {
    dispatch(deleteAirport(airport_id))
      .then(() => {
        toast.success(
          `Airport deleted successfuly`,
          { autoClose: 1250, position: toast.POSITION.BOTTOM_CENTER }
        );
      })
      .catch(() => {
        toast.error(
          `This airport can't be deleted due to links in the app.`,
          { autoClose: 1250, position: toast.POSITION.BOTTOM_CENTER }
        );
        dispatch(clearMessage());
      });
  }

  const columns = [
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'name', headerName: 'Name', editable: true, flex: 1 },
    {
      field: 'actions',
      type: 'actions',
      sortable: false,
      getActions: (params) => {
        return [<GridActionsCellItem icon={params.id > 0 ? <DeleteIcon /> : <></>} onClick={() => delete_airport(params.id)} />]
      }
    }];

  return (
    <div>
      <div className="container">
        <div className="justify-content-end d-flex p-3 m-6">
          <Filter
            setSearchQuery={HandleFilter}
            searchQuery={filter}
            helper={searchBarHelper}
            setActive={updateActiveFilter}
            addDataFunction={() => handleClickOpenDialog()}
          />

          <NewAirportModal
            show={modalShow}
            setSelectedAirport={setSelectedAirport}
            selectedAirport={selectedAirport}
            handleSubmit={upsert_airport}
            onHide={() => handleCloseDialog(false)}>
          </NewAirportModal>

        </div>
      </div>
      {
        listAirports ?
          <div style={{ height: 400, width: '100%' }}>
            <DataGrid
              component={Paper}
              rows={
                listAirports.filter(filterAirports).map((airport) => {
                  return airport;
                })}
              columns={columns}
              onRowClick={handleRowClick}
              initialState={{ pinnedColumns: { right: ['actions'] } }}
              getRowClassName={(params) => {
                return !params.row.id ? `row-parent` : `row-child-${(listAirports.filter((u) => u.id == params.row.id)[0].active ? "active" : "inactive")}`
              }}
            />
          </div> : <></>
      }
    </div>
  )
};

export default Airport;